import script from "./submit.vue?vue&type=script&setup=true&lang=js"
export * from "./submit.vue?vue&type=script&setup=true&lang=js"

import "./submit.vue?vue&type=style&index=0&id=63276ee2&lang=scss&scoped=true"

import exportComponent from "E:\\newwww\\shared_space\\shared_agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63276ee2"]])

export default __exports__